module.exports = __webpack_public_path__ + "img/1.d7e67d8f.jpg";